import NavigationMenu from './navigation-menu';

export default NavigationMenu;
